import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import ThemeSwitcher from "@/components/ThemeSwitcher";
import { trackEvent } from "@/lib/api";
import { BrandMark } from "./BrandMark";
import { MobileMenu } from "./MobileMenu";

export const LandingHeader = () => (
    <header className="sticky top-0 z-50 border-b border-border/60 bg-background/85 backdrop-blur-md">
        <div className="max-w-7xl mx-auto px-4 sm:px-10 h-16 sm:h-20 flex items-center justify-between gap-3">
            <BrandMark />
            {/* Desktop nav */}
            <nav className="hidden sm:flex items-center gap-6 mono-label shrink-0">
                <Link
                    to="/pricing"
                    className="hover:text-foreground transition-colors whitespace-nowrap"
                    data-testid="nav-pricing"
                >
                    Pricing
                </Link>
                <a
                    href="#templates"
                    className="hover:text-foreground transition-colors whitespace-nowrap"
                    data-testid="nav-templates"
                >
                    Templates
                </a>
                <Link
                    to="/security"
                    className="hover:text-foreground transition-colors whitespace-nowrap"
                    data-testid="nav-security"
                >
                    Security
                </Link>
            </nav>
            <div className="hidden sm:flex items-center gap-2 shrink-0">
                <ThemeSwitcher compact />
                <Link to="/login">
                    <Button
                        className="rounded-md font-display px-6"
                        data-testid="landing-login-btn"
                        onClick={() =>
                            trackEvent("landing_cta_click", {
                                location: "header",
                                label: "sign_in",
                            })
                        }
                    >
                        Sign In
                    </Button>
                </Link>
            </div>

            {/* Mobile: login stays visible top-right */}
            <div className="flex sm:hidden items-center gap-2 shrink-0">
                <Link to="/login" className="max-[359px]:hidden">
                    <Button
                        variant="ghost"
                        size="sm"
                        className="rounded-md font-display px-4"
                        data-testid="landing-login-btn-mobile"
                        onClick={() =>
                            trackEvent("landing_cta_click", {
                                location: "header_mobile",
                                label: "sign_in",
                            })
                        }
                    >
                        Sign in
                    </Button>
                </Link>
                <MobileMenu />
            </div>
        </div>
    </header>
);
